import React, { useRef, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import Sidebaroptions from "src/Components/SidebarOption";
import settingsStyles from "src/Assets/css/settings/settings.module.css";
// import { StylesContext } from '@material-ui/styles';
import Notifications from "src/pages/Notifications";
import HeaderAfterSignIn from "../../Components/Header/header";
import logo from "src/Assets/images/LandingPageImages/skopic-image.png";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";
import Cookies from "js-cookie";
import API from "../../network";
import "./index.css";
import { useSelector } from "react-redux";

const defaultState = {
  says: false,
  asks: false,
  // postingResponses: false,
  updates: false,
  tags: false,
  following: false,
  contributors: false,
  moderators: false,
  other: false,
};

function Help() {
  const saysRef = useRef(null);
  const asksRef = useRef(null);
  // const postingResponsesRef = useRef(null);
  const updatesRef = useRef(null);
  const tagsRef = useRef(null);
  const followingRef = useRef(null);
  const contributorsRef = useRef(null);
  const moderatorsRef = useRef(null);
  const otherRef = useRef(null);

  const communityContext = useContext(CommunityContext);
  const settingsData = useSelector((state) => state.voteupReducer.settingsData);

  const [isActive, setIsActive] = useState({
    ...defaultState,
    says: true,
  });
  const [signInStatus, setSignInStatus] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const status = Cookies.get("signInStatus");
    setSignInStatus(status);
  }, []);

  const clickHandler = (key) => {
    setIsActive({
      ...defaultState,
      [key]: true,
    });

    scrollToView(key);
  };

  const onSkopicClick = async () => {
    try {
      const response = await API.changeCommunity(
        settingsData?.userTenant,
        settingsData?.userTenantId,
      );
      if (response) {
        communityContext?.onChangeCommunity({
          tenantId: settingsData?.userTenantId,
          tenantName: settingsData?.userTenant,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const scrollToView = (key) => {
    if (key === "says" && saysRef.current) {
      saysRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "asks" && asksRef.current) {
      asksRef.current?.scrollIntoView({ behavior: "smooth" });
      // } else if (key === "postingResponses" && postingResponsesRef.current) {
      //   postingResponsesRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "updates" && updatesRef.current) {
      updatesRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "tags" && tagsRef.current) {
      tagsRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "following" && followingRef.current) {
      followingRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "contributors" && contributorsRef.current) {
      contributorsRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "moderators" && moderatorsRef.current) {
      moderatorsRef.current?.scrollIntoView({ behavior: "smooth" });
    } else if (key === "other" && otherRef.current) {
      otherRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isNotificationSelected, setIsNotificationSelected] = useState(false);

  const showHideNotifications = () => {
    setIsNotificationSelected(!isNotificationSelected);
  };

  return (
    <div className="footer-main-container" style={{ marginTop: "50px" }}>
      {isNotificationSelected ? (
        <div className={`col-sm-3  ${settingsStyles.notifications}`}>
          <div className={settingsStyles.notificationscroll}>
            <Notifications />
          </div>
        </div>
      ) : null}
      <div>
        {signInStatus === "true" ? (
          <HeaderAfterSignIn onSkopicClick={onSkopicClick} />
        ) : (
          <div className={settingsStyles.headerContainer}>
            <Link to={"/"}>
              <div>
                <img src={logo} alt="Skopic-Logo" width={90} height={48} />
              </div>
            </Link>
          </div>
        )}
        <div className="careers-main-container">
          <div className="page-navigation-options-container">
            {/* <h3>Help</h3> */}
            <div className="main-heading-container">
              <h3 className="main-heading">Help</h3>
            </div>
            <div className="page-navigation-options">
              <div className="page-options-content">
                <Sidebaroptions
                  active={isActive.says}
                  text="SAYs"
                  onSidebaroptionClick={() => clickHandler("says")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.asks}
                  text="ASKs"
                  onSidebaroptionClick={() => clickHandler("asks")}
                />
                {/* <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.postingResponses}
                  text="Postings Responses"
                  onSidebaroptionClick={() => clickHandler("postingResponses")}
                />*/}
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.updates}
                  text="UPDATEs"
                  onSidebaroptionClick={() => clickHandler("updates")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.tags}
                  text="TAGs"
                  onSidebaroptionClick={() => clickHandler("tags")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.following}
                  text="Following"
                  onSidebaroptionClick={() => clickHandler("following")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.contributors}
                  text="Contributors"
                  onSidebaroptionClick={() => clickHandler("contributors")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.moderators}
                  text="Moderators"
                  onSidebaroptionClick={() => clickHandler("moderators")}
                />
                <Divider variant="fullWidth"></Divider>
                <Sidebaroptions
                  active={isActive.other}
                  text="Other"
                  onSidebaroptionClick={() => clickHandler("other")}
                />
              </div>
            </div>
          </div>
          <div className="careers-content-container">
            <div
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              }  ${isActive.says && settingsStyles.focusapperance}`}
            >
              <p>
                Skopic's information-networking platform builds stronger and
                thriving local Communities globally by letting people engage,
                learn and get organized on real matters related to everyday
                living.
              </p>
              <p>
                On Skopic users can author and publish 280-character microblogs
                in four main post categories.
              </p>
            </div>
            <div
              ref={saysRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              }  ${isActive.says && settingsStyles.focusapperance}`}
            >
              {/* <div className={settingsStyles.help}> */}
              <h5 className="help-main-heading">1.SAY:</h5>
              <p>
                SAY lets you share knowledge and express thoughts that benefit
                your community. Your insights build collective knowledge in your
                community and may answer peers’ questions. Once posted, SAY
                appears inthe community feed.
              </p>
              Additionally, previously posted questions (ASKs) will be suggested
              on the related subject if available. You can choose to answer
              these questions if you like.
              {/* </div> */}
            </div>
            <div
              ref={asksRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              }  ${isActive.asks && settingsStyles.focusapperance}`}
            >
              {/* <div className={settingsStyles.sidebarchildoptionsocialmediapswdchange}> */}
              {/* <div> */}
              <h5 className="help-main-heading">2. ASK:</h5>
              <p>
                ASK a question in your community. Skopic instantly finds matches
                from SAYs and past answers. If results are not helpful, tap “ASK
                Community” to post it to the feed. You will get email and in-app
                notifications when peers respond.
              </p>
              <br />

              <h5 className="subHeading">
                Answers to Open Questions (ASKs) in your community:
              </h5>
              <p>
                Answer open questions (ASKs) in your community by tapping
                “Answer,” or view existing responses and post your own Answer.
              </p>
              {/* </div> */}
              {/* </div> */}
            </div>
            {/* <div
              ref={postingResponsesRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.postingResponses && settingsStyles.focusapperance}`}
            >
              {/* <div> */}
            {/* <h5 className="help-main-heading">
                POSTING RESPONSES, a.k.a SAY to Open Questions, a.k.a ASKs in
                your community:
              </h5>
              You can choose to respond a.k.a SAY to any Open Question a.k.a ASK
              by clicking on the SAY option or alternatively click on SAYs to
              view previously posted answers and then share your best informed
              answer not exceeding 280 chat limit. Also, note URL or web links
              can be embedded but they would not counted towards the max
              character limit.
              {/* </div> */}
            {/* </div> */}

            <div
              ref={updatesRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.updates && settingsStyles.focusapperance}`}
            >
              {/* <div> */}
              <h5 className="help-main-heading">3. UPDATE:</h5>
              <p>
                Share important news or information with your community using
                UPDATE. Broadcast messages to all members in your community.
                You’ll receive in-app and email notifications whenever an UPDATE
                is posted. A reminder can be set while creating UPDATE so
                rebroadcast will occur accordingly.
              </p>
              <br />
              <p>
                Users can post a single UPDATE across multiple communities if
                they are moderating in those communities.
              </p>

              {/* </div> */}
            </div>

            <div
              ref={tagsRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.tags && settingsStyles.focusapperance}`}
            >
              {/* <div> */}
              <h5 className="help-main-heading">4. TAG:</h5>
              <p>
                Create #TAGs to organize topics, events, and groups in your
                community. Members are notified when anew #TAG is created and
                can choose to follow it. You can also add a description for the
                #TAG.
              </p>

              <br />

              <p>
                When members post Replies to followed #TAGs, email and push
                notifications are sent to everyone following the #TAG. Posting
                Reply to a #TAG auto-follows it.
              </p>
              <br />
              <h5 className="subHeading">
                Common features for above post categories:
              </h5>
              <ul>
                <li>One attachment can be included to the post</li>
                <li>Location can be added to the post</li>
                <li>
                  URLs/links don’t count toward the character limit in the post
                </li>
              </ul>
              {/* </div> */}
            </div>

            <div
              ref={followingRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.following && settingsStyles.focusapperance}`}
            >
              {/* <div> */}
              <h5 className="help-main-heading">Following:</h5>
              <h5 className="subHeading">
                Three things users can Follow on Skopic:
              </h5>
              <ol>
                <li>Community</li>
                <p>
                  You can follow any community by using the “Follow” option on
                  the community home page or from your profile.
                </p>
                <p>There are three types of communities on Skopic:</p>
                <ul>
                  <li>
                    Public communities can be followed immediately without any
                    approval
                  </li>
                  <li>
                    Private communities that are visible to users can be
                    followed if invited by a moderator or followed once the join
                    request is approved by a moderator
                  </li>
                  <li>
                    Private communities that are hidden from the user view can
                    be followed only if invited by a moderator
                  </li>
                </ul>
                <br />
                <p>
                  {" "}
                  When you follow a community, you’ll receive notifications when
                  new #TAGs are created and when UPDATEs are posted.
                </p>

                <p>
                  You can unfollow any community at any time from your profile
                  page.
                </p>
                <li>ASK</li>
                <p>
                  You can follow any ASK that is of interest to you. When other
                  members post an answer, you will receive both email and in-app
                  notification.
                </p>

                <li>TAG</li>
                <p>
                  You can follow #TAGs to stay connected with specific topics,
                  activities, and groups within your community. When members
                  post a reply to a followed #TAG, you will receive both email
                  and in-appnotification helping you stay up to date on
                  conversations that matter to you.
                </p>
              </ol>
              <br />

              {/* </div> */}
            </div>

            <div
              ref={contributorsRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.contributors && settingsStyles.focusapperance}`}
            >
              {/* <div> */}
              <h5 className="help-main-heading">Community Contributors:</h5>
              <p>
                The top 12 users who contribute the most to community knowledge
                are featured as Contributors on the community home page.
                Contributions to community knowledge include posting SAYs,
                UPDATEs and providing Answers to ASKs.
              </p>
              {/* </div> */}
            </div>

            <div
              ref={moderatorsRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.moderators && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Community Moderator:</h5>
              <p>
                The user who requests to start a new community is automatically
                assigned the role of “Primary Moderator” once the community is
                approved.
              </p>

              <p>The Primary Moderator can:</p>
              <ol>
                <li>Invite members to become “Secondary Moderators”, or</li>
                <li>
                  Approve requests from members who apply for moderator roles
                  through their profile page
                </li>
              </ol>

              <p>
                There can be one or more Secondary Moderators supporting the
                community.
              </p>

              <p>
                The Primary Moderator can set rule for each post category if it
                should require an approval for publishing in the community feed.
              </p>
              <br />
            </div>

            <div
              ref={otherRef}
              className={`${settingsStyles.sidebarChildContentOptions} ${
                settingsStyles.help
              } ${isActive.other && settingsStyles.focusapperance}`}
            >
              <h5 className="help-main-heading">Others:</h5>
              <h5 className="sideHeading">
                Sign-Up Process for creating Skopic account:
              </h5>
              <p>
                Creating an account on Skopic is quick and easy. The two
                important steps for successfully Signing up on Skopic are
                selection of Default Community and Email verification.
              </p>
              <h5 className="sideHeading">
                Sign Up or Sign In with Google or Apple ID:
              </h5>
              <p>
                Users can quickly sign up or sign in to Skopic using their
                Google or Apple ID.
              </p>
              <p>
                When signing up with Google or Apple:
                <ul>
                  <li>
                    Basic profile information from your Google or Apple account
                    is used to create your Skopic profile.
                  </li>
                  <li>
                    The process is faster since you can skip the email
                    verification step.
                  </li>
                </ul>
              </p>
              {/* Popular Social Media Integrations:
              <br /> */}
              {/* On the Settings page, you can enable your Skopic posts to be
              posted on Facebook (Groups,
              <br />
              Pages, and your personal Timeline), LinkedIn, and Twitter.
              <br /> */}
              <h5 className="sideHeading">Default Community:</h5>
              <p>
                During sign-up, you’ll be asked to select a default community to
                complete the process. Once your account is created, you will be
                directed to the home page of your default community each time
                you log in.
              </p>
              <p>
                You can change your default community at any time:
                <ul>
                  <li>
                    From the Communities Following section in your profile
                  </li>
                  <li>
                    By visiting the Follow More Communities page from the
                    community home page or your profile
                  </li>
                </ul>
              </p>
              <p>
                The second option allows you to search and select a new default
                community outside of the communities you currently follow.
              </p>

              <h5 className="sideHeading">Request to Start a New Community:</h5>
              <p>
                Users can request to create a new community on Skopic by
                completing and submitting a form. This can be done either during
                the sign-up process or at any time afterwards.
                <ul>
                  <li>
                    During sign-up: The “Start Community” button is available
                    within the “Default Community Selection” page.
                  </li>
                  <li>
                    After sign-up: Users can access the “Start Community” form
                    in the “Follow More Communities” page or in the profile
                    page.
                  </li>
                </ul>
              </p>
              <p>
                Once the request is submitted, the user must verify it by
                clicking the confirmation link sent via email. After
                verification, the Skopic administrator reviews and approves the
                new community. The user will be notified as soon as the
                community is approved and becomes active on Skopic.
              </p>
              <p>
                If community is created during sign-up, once the community is
                activated it will become the default community for the user.
              </p>
              <h5 className="sideHeading">Trending TAGs:</h5>
              <p>
                Trending TAGs are shown on the community home page. These
                represent conversations that are gaining high interest within
                the community, receiving a large number of replies and
                followers.
              </p>
              <h5 className="sideHeading">Trending ASKs:</h5>
              <p>
                Trending ASKs are shown on the community home page. These are
                questions attracting significant attention, with many answers
                and followers.
              </p>
              <h5 className="sideHeading">Liking Posts:</h5>
              <p>
                Users can like the following types of post:
                <ul>
                  <li>SAYs</li>
                  <li>UPDATEs</li>
                  <li>Answers to ASKs</li>
                  <li>Replies to TAGs</li>
                </ul>
              </p>
              <br />
              <h5 className="sideHeading">Send Message to a User:</h5>
              <p>
                You can contact the author of any post by sending them an email
                to connect offline. This option is available in the menu on each
                post.
              </p>
              <h5 className="sideHeading">Report Abuse:</h5>
              <p>
                You can report any post by selecting the “Report this post”
                option and providing a reason. This option is provided in the
                menu on each post. Once submitted, both the community moderator
                and the user whose post was flagged will be notified.
              </p>
              <br />
              <p>
                For more help or if you have any further questions, reach us via contact on{' '}
                <a href="https://www.skopic.com" target="_blank" rel="noopener noreferrer">
                  www.skopic.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;
